import {
    FETCH_DELETE_ANNOUNCEMENTS_REQUEST,
    FETCH_DELETE_ANNOUNCEMENTS_SUCCESS,
    FETCH_DELETE_ANNOUNCEMENTS_FAILURE,
} from '../../actions/announcement/delete-announcement-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteAnnouncementReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_ANNOUNCEMENTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_ANNOUNCEMENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteAnnouncementReducer;